var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav-item-wrapper"},[_c('DsIcon',{attrs:{"name":_vm.tab.icon}}),_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t(`nav.menu.${_vm.tab.label}`)))]),(_vm.tab.external)?_c('div',{staticClass:"external-link-icon"},[_c('DsIcon',{attrs:{"name":"external-link"}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }